import { ChangeDetectionStrategy, Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { RegexConstants, RegexValidator } from '../../core/utility/lgv-regex-validator';
import { LgvClientService, NotificationService } from '../../core/core.module';
import { BehaviorSubject, Subject, catchError, of, takeUntil } from 'rxjs';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';
import { InfoHeader } from '../../modules/client/controls/complete-profile-stepper/info-message.enum';
import { InfoPopup } from '../info-popup/info-popup.component';

@Component({
    selector: 'lgv-create-account-modal',
    templateUrl: './create-account-modal.component.html',
    styleUrls: ['./create-account-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CreateAccountModalComponent implements OnInit, OnDestroy {
    createAccountForm: UntypedFormGroup;
    onDestroy$ = new Subject();
    isLoading$ = new BehaviorSubject(false);
    constructor(public dialogRef: MatDialogRef<CreateAccountModalComponent>,
        @Inject(MAT_DIALOG_DATA)
        private data: any,
        private fb: FormBuilder,
        private clientService: LgvClientService,
        private notifService: NotificationService,
        private dialog: MatDialog) { }

    ngOnInit(): void {
        this.createAccountForm = this.fb.group({
            firstName: ['', [Validators.required]],
            lastName: ['', [Validators.required]],
            email: ['', [RegexValidator(RegexConstants.EMAIL), Validators.required]],
            phone: ['', [Validators.required]],
        });
    }

    ngOnDestroy(): void {
       this.onDestroy$.next(true);
       this.onDestroy$.complete(); 
    }

    onSignUp() {
        this.isLoading$.next(true);
        const clientModel = {
            firstName: this.createAccountForm.get('firstName').value,
            lastName: this.createAccountForm.get('lastName').value,
            email: this.createAccountForm.get('email').value,
            mobilePhone: this.createAccountForm.get('phone').value,
            ownerId: this.data?.agentId,
            isPropertylessClient: true
        }
        this.clientService.addPublicClient(clientModel).pipe(
            takeUntil(this.onDestroy$),
            catchError((err) => {
                this.notifService.error('Failed to add a Client.');
                return of({
                    err: true
                })
            })
        ).subscribe((response) => {
            this.isLoading$.next(false);
            if(!response?.err) {
                this.dialog.open(InfoPopup, {
                    data: {
                        header: `Success!`,
                        body: `Check your email for the link to access your HomeDashboard account.`,
                        mode: 'generic'
                    }
                })
            }
            this.dialogRef.close();
        });
    }
}
